<template>
  <section class="slide-vertical">
    <nav class="slide-nav">
      <ul>
        <li>
          <a href="#" :class="{ active: isSlide('people') }" @click.prevent
            @mouseover="changeVertical('people')">Pessoas</a>
        </li>
        <li>
          <a href="#" :class="{ active: isSlide('process') }" @click.prevent
            @mouseover="changeVertical('process')">Processos</a>
        </li>
        <li>
          <a href="#" :class="{ active: isSlide('experience') }" @click.prevent
            @mouseover="changeVertical('experience')">Cliente</a>
        </li>
        <li>
          <a href="#" :class="{ active: isSlide('strategy') }" @click.prevent
            @mouseover="changeVertical('strategy')">Estratégia</a>
        </li>
      </ul>
    </nav>
    <div class="slide-area">
      <transition name="fade" mode="out-in">
        <div class="slide-item people" v-if="slideVertical == 'people'" key="1">
          <div class="description">
            A Transformação Digital é sobre pessoas, não tecnologia. Qualquer evolução organizacional é pautada na liderança exercida pelos colaboradores em um ambiente propício, assegurado por uma cultura construída ao redor do digital.
          </div>
        </div>
        <div class="slide-item process" v-if="slideVertical == 'process'" key="2">
          <div class="description">
            A jornada pela Transformação Digital é traçada com base em processos que se beneficiam das expertises de todos os setores trabalhando em conjunto. Metas só são atingidas quando a organização opera de forma colaborativa e compartilhada.
          </div>
        </div>
        <div class="slide-item experience" v-if="slideVertical == 'experience'" key="3">
          <div class="description">
            O mercado deixou de ditar as regras. Agora, os consumidores criam demandas para serem supridas pelas empresas - que, por sua vez, trabalham para garantir experiências novas e únicas, fechando assim o ciclo da Transformação Digital.
          </div>
        </div>
        <div class="slide-item strategy" v-if="slideVertical == 'strategy'" key="4">
          <div class="description">
            Para se adaptar à Transformação Digital é necessário desenvolver estratégias que sejam compatíveis às mudanças constantes, suportadas por um ecossistema de cultura, mindset e processos digitais alinhados aos mesmos objetivos.
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: 'slide-vertical',
  data() {
    return {
      slideVertical: 'people',
    };
  },
  methods: {
    changeVertical(name) {
      this.slideVertical = name;
    },
    isSlide(name) {
      return this.slideVertical === name;
    },
  },
};
</script>

<style lang="scss" scoped>
  $color-title: #121416;

  .slide-vertical {
    position: relative;
    height: 100%;
    width: 100%;
    .slide-nav {
      position: absolute;
      top: 60px;
      left: -75px;
      z-index: 1;
      @media (max-width: 576px) {
        left: -25px;
        top: 0;
      }
      ul {
        list-style: none;
        padding: 0;
        a {
          display: inline-block;
          text-transform: uppercase;
          text-decoration: none;
          padding: 2px 6px;
          font-size: 24px;
          line-height: 28px;
          color: $color-title;
          margin-bottom: 10px;
          transition: color .3s;
          letter-spacing: 5px;
          text-indent: 5px;
          @media (max-width: 576px) {
            letter-spacing: 2px;
            text-indent: 2px;
          }
          &:hover,
          &.active {
            color: white;
            background-color: black;
          }
        }
      }
    }
    .slide-area {
      position: relative;
      display: flex;
      overflow: hidden;
      width: 720px;
      height: 393.5px;
      background-color: #d7d7d7;
      @media (max-width: 576px) {
        width: 100%;
      }
    }
    .slide-item {
      width: 720px;
      background-position: center center;
      background-size: cover;
      @media (max-width: 576px) {
        width: 100%;
      }
      &.people {
        background-image: url(./../assets/img/slide-pessoas.jpg);
      }
      &.process {
        background-image: url(./../assets/img/slide-processos.jpg);
      }
      &.experience {
        background-image: url(./../assets/img/slide-experiencia.jpg);
      }
      &.strategy {
        background-image: url(./../assets/img/slide-estrategia.jpg);
      }
      .description {
        position: absolute;
        color: white;
        font-size: 18px;
        line-height: 29px;
        top: 80px;
        right: 60px;
        width: 40%;
        z-index: 1;
        @media (max-width: 576px) {
          width: auto;
          right: 0;
          bottom: 20px;
          top: initial;
          padding: 0 25px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SlideVertical.vue